import type { SearchUsersState } from '@efdigital/ll-admin-v2/components/search/search-users.gts';
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class LibraryUsersIndexController extends Controller {
  queryParams = ['text'];

  @tracked text = '';

  serializeText(value: string) {
    return value.trim() || undefined;
  }

  setState = (state: Partial<SearchUsersState>) => {
    if (state.text !== undefined) {
      this.text = state.text;
    }
  };
}
